import { EGenerateQuizQuestionOptions } from '@constants';
import { ICourse, IQuiz } from '@sdk/contracts';
import { useEffect } from 'react';
import { create } from 'zustand';

import { useProfile } from '@/store';

interface IStore {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  selectedCourse?: ICourse;
  setSelectedCourse: (course?: ICourse) => void;
  selectedTag?: string;
  setSelectedTag: (tag?: string) => void;
  questionTypes: EGenerateQuizQuestionOptions[];
  setQuestionTypes: (questionTypes: EGenerateQuizQuestionOptions[]) => void;
  selectedSections: string[];
  setSelectedSections: (sections: string[]) => void;
  selectedQuiz?: IQuiz;
  setSelectedQuiz: (quiz?: IQuiz) => void;
}

const store = create<IStore>(set => ({
  currentStep: 0,
  setCurrentStep: step => set({ currentStep: step }),
  selectedCourse: undefined,
  setSelectedCourse: course => set({ selectedCourse: course }),
  selectedTag: undefined,
  setSelectedTag: tag => set({ selectedTag: tag }),
  questionTypes: [],
  setQuestionTypes: questionTypes => set({ questionTypes }),
  selectedSections: [],
  setSelectedSections: sections => set({ selectedSections: sections }),
  selectedQuiz: undefined,
  setSelectedQuiz: quiz => set({ selectedQuiz: quiz })
}));

export const useQuizConfigurationStore = () => {
  const {
    currentStep,
    setCurrentStep,
    selectedCourse,
    setSelectedCourse,
    selectedTag,
    setSelectedTag,
    questionTypes,
    setQuestionTypes,
    selectedSections,
    setSelectedSections,
    selectedQuiz,
    setSelectedQuiz
  } = store();
  const { profile } = useProfile();

  useEffect(() => {
    if (profile?.tags.length && !selectedTag) setSelectedTag(profile?.tags[0]?._id);
  }, [profile?.tags]);

  const resetStore = () => {
    setCurrentStep(0);
    setSelectedCourse(undefined);
    setQuestionTypes([]);
    setSelectedSections([]);
    setSelectedQuiz(undefined);
  };

  return {
    currentStep,
    setCurrentStep,
    selectedCourse,
    setSelectedCourse,
    selectedTag,
    setSelectedTag,
    questionTypes,
    setQuestionTypes,
    selectedSections,
    setSelectedSections,
    selectedQuiz,
    setSelectedQuiz,
    resetStore
  };
};
